<template>
  <div>
    <!-- Content Header (Page header) -->
    <!-- Main content -->
    <section class="content">
          <div class="box box-info">
            <div class="box-header with-border">
              
            </div>
            <div class="box-body">
              <div class="row">
                <div class="col-md-3" >
                  <label for="Branch">Branch</label>
                  <v-select v-model="branch" name="branch_id" label="name" :options="branches" placeholder="Select Branch" v-on:input="getRecordBranchWise"></v-select>
                  
                  <has-error
                    :form="form"
                    field="branch_id"
                  ></has-error>
                </div>
                <div class="col-md-3">
                  <label for="Type">Loan Type</label>
                  <select
                    v-model="form.loanType"
                    name="loanType"
                    @change="getRecordBranchWise"
                    class="form-control"
                    :class="{
                      'is-invalid': form.errors.has('loanType'),
                    }"
                    required
                  >
                    <option value="">All</option>
                    <option value="group">Group</option>
                    <option value="individual">Individual</option>
                  </select>
                  <has-error
                    :form="form"
                    field="loanType"
                  ></has-error>
                </div>
                <div class="col-md-3">

                  <div class="form-group">
                    <label
                      >Recovery type
                      <span class="red">*</span></label
                    >
                    <select
                      v-model="form.recoveryType"
                      name="recoveryType"
                      class="form-control"
                      @change="changeFilter"
                      :class="{
                        'is-invalid': form.errors.has(
                          'recoveryType'
                        ),
                      }"
                    >
                      <option value="">All</option>
                      <option value="Daily">Daily</option>
                      <option value="Weekly">Weekly</option>
                      <option value="BiWeekly">BiWeekly</option>
                      <option value="HalfMonth">Half Month</option>
                      <option value="Monthly">Monthly</option>
                      <option value="Yearly">Yearly</option>
                      <option value="OneTime">One Time</option>

                    </select>
                    <has-error
                      :form="form"
                      field="recoveryType"
                    ></has-error>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label
                      >Select Plan Type
                      <span class="red">*</span></label
                    >
                    <select
                      v-model="form.planType"
                      name="planType"
                      class="form-control"
                      @change="changeFilter"
                    >
                      <option value="">All</option>
                      <option value="normal">Normal Plan</option>
                      <option value="normalReduced">Normal Reduced Plan</option>
                      <option value="special">Special Plan</option>
                      <option value="custom">Custom Plan</option>
                      <option value="manual">Manual Plan</option>
                    </select>
                    <has-error :form="form" field="planType"></has-error>
                  </div>
                </div>
                <div class="col-md-3" v-if="form.loanType === 'group' && form.branch_id !== ''">
                  <label for="Branch">Group</label>
                  <v-select v-model="collectionCenter"  name="collection_center_id" label="name" :options="collectionCenters" placeholder="Select Group" v-on:input="getRecordCenterWise" required></v-select>
                  <has-error
                    :form="form"
                    field="branch_id"
                  ></has-error>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label
                      >Payment Type <span class="red">*</span></label
                    >
                    <select
                      v-model="form.type"
                      name="type"
                      @change="changeFilter"
                      class="form-control"
                      :class="{
                        'is-invalid': form.errors.has('type'),
                      }"
                    >
                      <option value="">All</option>
                      <option value="processingFee">Processing Fee</option>
                      <option value="fileCharge">File Charge</option>
                      <option value="emi">EMI</option>
                    </select>
                    <has-error :form="form" field="type"></has-error>
                  </div>
                </div>
                <div class="col-md-3">
                  <div class="form-group">
                    <label
                      >Select Payment Status <span class="red">*</span></label
                    >
                    <select
                      v-model="form.status"
                      name="status"
                      @change="changeFilter"
                      class="form-control"
                      :class="{
                        'is-invalid': form.errors.has('status'),
                      }"
                    >
                      <option value="">All</option>
                      <option value="approved">Approved</option>
                      <option value="pending">Pending</option>
                    </select>
                    <has-error :form="form" field="status"></has-error>
                  </div>
                </div>
                <div class="col-md-3">
                  <label for="Branch">Staff (Type Here)</label>
                  <v-select v-model="staff" name="staff_id" :filterable="false" label="name" :options="staffs" placeholder="Select Staff" @search="getStaffRecord" v-on:input="getRecordAgentWise"></v-select>
                  
                  <has-error
                    :form="form"
                    field="staff_id"
                  ></has-error>
                </div>
                <div class="col-md-3">
                  <label for="Branch">Member (Type Here)</label>
                  <v-select v-model="member" name="member_id" :filterable="false" label="name" :options="members" placeholder="Select Member" @search="getMemberRecord" v-on:input="getRecordMemberWise"></v-select>
                  
                  <has-error
                    :form="form"
                    field="staff_id"
                  ></has-error>
                </div>
              </div>
              <div class="row">
                <div class="col-md-3">
                  <label for="date">Payment Date</label>
                  <input type="date" v-model="form.paymentDate" name="paymentDate" class="form-control" @change="selectPaymentDate" placeholder="EMI Date">
                </div>
                <div class="col-md-3">
                  <label for="date">Payment Start Date</label>
                  <input type="date" v-model="form.paymentStartDate" name="paymentStartDate" class="form-control" @change="selectBetweenPaymentDate" placeholder="EMI Start Date">
                </div>
                <div class="col-md-3">
                  <label for="date">Payment End Date</label>
                  <input type="date" v-model="form.paymentEndDate" name="paymentEndDate" class="form-control" @change="selectBetweenPaymentDate" placeholder="EMI End Date">
                </div>
              </div>
            </div>
            <!-- /.box-body -->
          </div>

          <!-- /.card -->
          <!-- <div class="box box-success">
            <div class="box-body">
              <div class="card">
                <div class="card-header">
                  <span class="pull-right">
                    
                  </span>
                  <h3 class="card-title">Member Collection <span class="pull-right" v-if="this.$store.state.user.type == 'admin'">Total Amount: {{this.totalAmount}}</span></h3>
                  
                </div>
                <div class="card-body table-sm">
                  <vue-good-table
                   
                    :isLoading.sync="isLoading"
                    :pagination-options="{
                      enabled: true
                    }"
                    :columns="columnsMemberCollections"
                    :rows="rowsMemberCollections"
                    styleClass="vgt-table condensed"
                    :search-options="{
                      enabled: true,
                      trigger: 'enter',
                    }"
                    :sort-options="{
                      enabled: true
                    }"
                  >
                    <template slot="table-row" slot-scope="props">
                      
                      <span v-if="props.column.field == 'Status'">
                        <span
                          v-if="props.row.status == 'pending'"
                          class="label label-warning"
                          >Pending</span
                        >
                        <span
                          v-if="props.row.status == 'paid'"
                          class="label label-success"
                          >Paid</span
                        >
                        <span
                          v-if="props.row.status == 'approved'"
                          class="label label-success"
                          >Approved</span
                        >
                        <span
                          v-if="props.row.status == 'partial'"
                          class="label label-info"
                          >Partial</span
                        >
                      </span>
                      <span v-if="props.column.field == 'id'">
                        
                      </span>
                      <span v-else>
                        {{ props.formattedRow[props.column.field] }}
                      </span>
                    </template>
                  </vue-good-table>
                </div>
              </div>
            </div>
          </div> -->
      <!-- /.row -->
      <!-- Default box -->
      <div class="info-box"  v-if="canAccess('member-loan-plan-view-any')">
        <div class="box-header with-border">
          <h3 class="box-title">Member Collection</h3>
          
          <div class="box-tools">
            <a :href="`${this.$axios.defaults.baseURL}/membercollection/export/excel`" class="btn btn-box-tool" v-if="canAccess('staff-create')">
              <i class="fa fa-file-excel-o"></i> Download Excel
            </a>
            <strong><big>Total Amount: {{this.totalAmount}} </big></strong>
          </div>

        </div>
        <div class="box-body">
          <!-- <div class="row">
            <div class="col-sm-6 col-xs-6">
              <label>
              </label>
            </div>
            <div class="col-sm-6">
              <div class="input-group pull-right input-group-sm">
                Total Amount: {{this.totalAmount}}
              </div>
            </div>
          </div> -->
          <table class="table table-sm table-bordered table-hover">
            <thead style="background-color: #d6dddd;">
              <tr>
                <th class="hidden-xs">Sr. No.</th>
                <th>LoanID </th>
                <th>Mem Name </th>
                <th>Mem Code </th>
                <th>Mobile</th>
                <th>Payment Type</th>
                <th>CenterName</th>
                <th class="hidden-xs">Pay Date</th>
                <th>Amount</th>
                <th>Received By</th>
                <th>Pay Mode</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in rowsMemberCollections" :key="index">
                <td class="hidden-xs">{{ (index +1) }}</td>
                <td><span v-if="row.member_loan_plan">{{ row.member_loan_plan.applicationNo }}</span></td>
                <td>{{ row.member.name }}</td>
                <td>{{ row.member.code }}</td>
                <td>{{ row.member.mobile }}</td>
                <td>{{ row.type }}</td>
                <td><span v-if="row.collection_center_id">{{ row.collection_center.name }}</span></td>
                <td class="hidden-xs">{{ row.paymentDate | myDate}}</td>
                <td>{{ row.amt }}</td>
                <td><span v-if="row.received_by">{{ row.received_by.name }}</span></td>
                <td><span v-if="row.branch_ledger">{{ row.branch_ledger.ledger.name }}</span></td>
                <td><span
                      v-if="row.status == 'pending'"
                      class="label label-warning"
                      >Pending</span
                    >
                    <span
                      v-if="row.status == 'paid'"
                      class="label label-success"
                      >Paid</span
                    >
                    <span
                      v-if="row.status == 'approved'"
                      class="label label-success"
                      >Approved</span
                    >
                    <span
                      v-if="row.status == 'partial'"
                      class="label label-info"
                      >Partial</span
                    >
                </td>
                <!-- <td>
                  <div class="btn-group">
                    <button
                      v-if="row.status === 'approved'"
                      @click="voucherView(row.id)"
                      class="btn btn-warning btn-xs"
                    >
                      <i class="fa fa-book" aria-hidden="true"></i>
                    </button>
                    <button
                      @click="printView(row)"
                      class="btn btn-warning btn-xs"
                    >
                      <i class="fa fa-print" aria-hidden="true"></i>
                    </button>
                    <button
                      v-if="canAccess('member-collection-delete')"
                      @click="confirmPayment(row)"
                      class="btn btn-danger btn-xs"
                    >
                    <i class="fa fa-trash"></i>
                    </button>
                  </div>
                </td> -->
              </tr>
            </tbody>
          </table>
        </div>
        <!-- /.box-body -->
      </div>
      <!-- /.box -->
    </section>
    <!-- /.content -->
  </div>
</template>

<script>
var _ = require('lodash')
export default {
  name: 'my-component',
  data () {
    return {
      table_search: '',
      isLoading: false,
      editMode: false,
      emiDate: null,
      collectionCenters: [],
      collectionCenter: {
        name: 'Select Group'
      },
      applicationNumber: '',
      memberCode: '',
      mobileNumber: '',
      adharCardNumber: '',
      pancardNumber: '',
      branches: [],
      branch: {},
      members: [],
      member: {},
      staffs: [],
      staff: {},
      banks: {},
      pl: {},
      seeRecord: {},
      loanplans: [],
      memberloanplans: [],
      memberloanplan: {},
      groupMembers: {},
      loadDisbursements: {},
      totalAmount: 0,
      viewCollectionCenter: '',
      totalRecords: 0,
      serverParams: {
        columnFilters: {
        },
        sort: {
          field: 'paymentDate',
          type: 'date'
        },
        page: 1,
        perPage: 10
      },
      form: new Form({
        id: '',
        collection_center_id: '',
        member_loan_plan_id: null,
        branch_id: '',
        agent_id: '',
        center_leader_id: '',
        plan_id: '',
        amt: '',
        plan: {},
        type: '',
        loanType: '',
        planType: '',
        receivedBy: '',
        recoveryType: '',
        member_id: '',
        status: '',
        disbursement_id: '',
        paymentDate: new Date().toISOString().slice(0, 10),
        paymentStartDate: '',
        paymentEndDate: '',
        paymentMode: '',
        bank_id: ''
      }),
      rowsMemberCollections: []
    }
  },
  methods: {
    canAccess (perm) {
      return this.$store.state.permissions.includes(perm)
    },
    getRecordAgentWise () {
      this.form.receivedBy = ''
      if (this.staff) {
        this.form.receivedBy = this.staff.user_id
      }
      this.changeFilter()
    },
    getRecordMemberWise () {
      this.form.member_id = ''
      if (this.member) {
        this.form.member_id = this.member.user_id
      }
      this.changeFilter()
    },
    getRecordBranchWise () {
      this.form.branch_id = ''
      this.form.receivedBy = ''
      this.staffs = []
      this.staff = {}
      this.collectionCenters = []
      this.collectionCenter = {}
      if (this.branch) {
        this.form.branch_id = this.branch.id
      }
      if (this.form.branch_id !== '' && this.form.loanType === 'group') {
        this.$axios.get('collectioncenter?all=all&branch_id=' + this.form.branch_id, {headers: { Authorization: 'Bearer ' + localStorage.token }})
          .then((response) => response.data)
          .then((data) => {
            this.collectionCenters = data.data
          })
          .catch(
            function (error) {
              Toast.fire({ icon: 'error', title: 'Please Try Again' })
              this.form.errors.errors = error.response.data.error
            }.bind(this)
          )
      }
      this.changeFilter()
    },
    getRecordCenterWise () {
      this.form.collection_center_id = ''
      if (this.collectionCenter) {
        this.form.collection_center_id = this.collectionCenter.id
      }
      this.changeFilter()
    },
    selectPaymentDate () {
      if (this.form.paymentDate) {
        this.form.paymentStartDate = ''
        this.form.paymentEndDate = ''
      }
      this.changeFilter()
    },
    selectBetweenPaymentDate () {
      if (this.form.paymentStartDate && this.form.paymentEndDate) {
        this.form.paymentDate = ''
        this.changeFilter()
      } else if (this.form.paymentStartDate === '' && this.form.paymentEndDate === '') {
        this.changeFilter()
      } else {
        this.form.paymentDate = ''
      }
    },
    changeFilter () {
      var c = JSON.parse(localStorage.user)
      if (c.type === 'staff') {
        this.branch.id = c.agent_profile.branch_id
      }
      // alert('hello')
      var pageUrl = ''
      pageUrl += 'membercollection?all=all'
      if (this.branch.id) {
        pageUrl += `&branch_id=${this.branch.id}`
      }
      if (this.form.receivedBy) {
        pageUrl += `&receivedBy=${this.form.receivedBy}`
      }
      if (this.form.member_id) {
        pageUrl += `&member_id=${this.form.member_id}`
      }
      if (this.form.loanType) {
        pageUrl += `&loanType=${this.form.loanType}`
      }
      if (this.form.recoveryType) {
        pageUrl += `&recoveryType=${this.form.recoveryType}`
      }
      if (this.form.planType) {
        pageUrl += `&planType=${this.form.planType}`
      }
      if (this.form.status) {
        pageUrl += `&status=${this.form.status}`
      }
      if (this.form.type) {
        pageUrl += `&type=${this.form.type}`
      }
      if (this.form.collection_center_id) {
        pageUrl += `&collection_center_id=${this.form.collection_center_id}`
      }
      if (this.form.paymentDate) {
        pageUrl += `&paymentDate=${this.form.paymentDate}`
      }
      if (this.form.paymentStartDate) {
        pageUrl += `&paymentStartDate=${this.form.paymentStartDate}`
      }
      if (this.form.paymentEndDate) {
        pageUrl += `&paymentEndDate=${this.form.paymentEndDate}`
      }
      this.$axios
        .get(pageUrl, {headers: { Authorization: 'Bearer ' + localStorage.token }}).then((response) => response.data)
        .then((data) => {
          this.totalAmount = _.sumBy(data.data, 'amt')
          this.rowsMemberCollections = data.data
        }).catch(function (error) { console.log(error) })
    },
    loadBranch () {
      this.$axios
        .get('branch?all=all&status=active', {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.branches = data.data
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    getStaffRecord (search, loading) {
      if (search.length > 2) {
        loading(true)
        this.$axios.get('staff?all=all&branch_id=' + this.form.branch_id + '&name=' + search, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.staffs = data.data
          _.forEach(this.staffs, function (item, key) {
            this.staffs[key].name = item.user.name + ' (' + item.user.code + ' - ' + item.user.mobile + ')'
          }.bind(this))
          loading(false)
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
      }
    },
    getMemberRecord (search, loading) {
      if (search.length > 2) {
        loading(true)
        this.$axios.get('member?all=all&branch_id=' + this.form.branch_id + '&name=' + search, {headers: { Authorization: 'Bearer ' + localStorage.token }})
        .then((response) => response.data)
        .then((data) => {
          this.members = data.data
          _.forEach(this.members, function (item, key) {
            this.members[key].name = item.user.name + ' (' + item.user.code + ' - ' + item.user.mobile + ')'
          }.bind(this))
          loading(false)
        })
        .catch(
          function (error) {
            Toast.fire({ icon: 'error', title: 'Please Try Again' })
            this.form.errors.errors = error.response.data.error
          }.bind(this)
        )
      }
    }
  },
  created () {
    this.loadBranch()
    this.changeFilter()
    Fire.$on('AfterCreate', () => {
      this.changeFilter()
    })
  }
}
</script>
<style scoped>
.content {
    padding: 0px;
  }
  .info-box {
    border-radius:10px;
    box-shadow: 0px 0px 3px gray;
  }
  .box-footer {
    border-radius:0px 0px 10px 10px;
  }
</style>




// WEBPACK FOOTER //
// CollectionReport.vue?06ccd5e1